import { CommonModule } from '@angular/common';
import { Component, effect, input, signal } from '@angular/core';
import { ImageTag } from 'src/app/components/banner/banner.component';
import { createDefaultBanner } from 'src/app/core/utilities/type-defaults.util';
import { Banner } from 'src/app/home/models/home.model';

@Component({
  standalone: true,
  selector: 'webstore-horizontal-banner',
  templateUrl: './horizontal-banner.component.html',
  styleUrls: ['./horizontal-banner.component.scss'],
  imports: [CommonModule]
})
export class HorizontalBannerComponent {




  readonly bannerInput = input<Banner>(createDefaultBanner());
  private _banner = signal<Banner>(createDefaultBanner());

  get banner() {
    return this._banner();
  }

  constructor() {
    effect(() => {
      const bannerValue = this.bannerInput();
      if (bannerValue) {
        this._banner.set(bannerValue);
      }
    });
  }

  get desktopUrl() {
    if (!this.banner?.images?.length) {
      return null;
    }
    return this.banner.images.find(image => image?.tag === ImageTag.desktop)?.url || '';
  }

  get mobileUrl() {
    if (!this.banner?.images?.length) {
      return null;
    }
    return this.banner?.images?.find(image => image?.tag === ImageTag.mobile)?.url || '';
  }

  get layoutMobileUrl() {
    if (!this.banner?.images?.length) {
      return null;
    }
    return this.banner.images.find(image => image?.tag === ImageTag.layoutCard)?.url || '';
  }

}

